// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transparent-navbar {
  background-color: rgba(255, 255, 255, 0.4);
}

.fixed-navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.mobile-navbar {
  background-color: rgba(0, 0, 0, 0.5);
}

.desktop-navbar {
  background-color: rgba(0, 0, 0, 0.5);
}

.logoNameNavbar {
  backdrop-filter: blur(5px);
  border-radius: 10px;
  font-weight: 800;
  text-shadow: 2px 2px 4px #000000, 0 13.36px 8.896px #d4d1a2, 0 -2px 1px #ffe600;
  color: rgb(233, 182, 16);
}


.logolinkname {
  font-weight: 900;
  font-family: 'Times New Roman', Times, serif;
  font-size: 20px;
  text-shadow: 0 13.96px 12.896px #e9b50a;
  color: rgb(233, 182, 16);
}

.logolinkname:hover {
  color: rgb(233, 182, 16);
  text-shadow: 0 13.96px 12.896px #41413e;

}

.logolinkname:visited {
  color: rgb(255, 255, 255);
  text-shadow: 0 13.96px 12.896px #41413e;

}

.logolinkname:active {
  color: rgb(255, 255, 255);
  text-shadow: 0 13.96px 12.896px #41413e;

}


.logolinkname:focus {
  color: rgb(255, 255, 255);
  text-shadow: 0 13.96px 12.896px #41413e;

}








.accordion-item {
  color: rgb(0, 0, 0);
  margin: 20px auto;
  font-family: 'Times New Roman', Times, serif;
  font-size: 17px;
  font-weight: bold;

}

.accordion-item:hover {
  background-color: orange;

}


.header-accordion-icon {
  color: rgb(255, 174, 0);
  border: 1px solid rgb(255, 115, 0);
  margin-left: 290px;
}



/* For extra small screens (e.g., iPhone SE) */
@media (max-width: 480px) {
  .header-accordion-icon {
    margin-left: 190px;
    /* Adjust as needed for smaller screens */
  }
}




@media (min-width: 1024px) {

  .logoNameNavbar {
    font-size: 1.8rem;
  }

  .navbar-toggler {
    display: none;
  }
}


@media (max-width: 1024px) {
  .transparent-navbar {
    background-color: white !important;
  }

  .logoNameNavbar {
    font-size: 1.5rem;
    margin-left: 20px;
  }
  .logolinkname{
    color: azure;
  }

  .menu-icon {
    position: absolute;
    right: 20px;
    top: 15px;
    width: 40px;
  }

  .navbar-collapse {
    border-radius: 5px;
    padding: 20px;
    margin-top: 10px;
    overflow: hidden;
    box-shadow: 0 19px 38px rgba(0, 0, 0, 0.30), 0 15px 12px rgba(0, 0, 0, 0.22);
  }
}

/* For tablets and larger phones */
@media (max-width: 768px) {
  .transparent-navbar {
    background-color: white !important;
    /* Set the navbar background to white */
  }

  .logoNameNavbar {
    font-size: 1.3rem;
    /* Smaller logo text */
    margin-left: 10px;
  }

  /* Positioning the menu icon to the right */
  .menu-icon {
    position: absolute;
    right: 20px;
    /* Align to the right */
    top: 15px;
    width: 35px;
    /* Adjust icon size for tablet view */
  }

  .navbar-collapse {
    max-height: 500px;
    /* Adjust height for tablets */
  }

  .navbar-toggler {
    padding: 0.25rem 0.5rem;
    border: none;
    /* Remove the border around the menu icon */
  }

  /* Aligning the navbar links and person icon */
  .navbar-nav {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  /* Smaller size for the person icon */
  .navbar-nav img {
    width: 20px;
    height: 20px;
  }
}

/* iPhone SE (Small mobile phones) */
@media (max-width: 375px) {
  .transparent-navbar {
    background-color: white !important;
    /* Set the navbar background to white */
  }

  .logoNameNavbar {
    font-size: 1.1rem;
    /* Even smaller logo for iPhone SE */
    margin-left: 10px;
  }

  .menu-icon {
    position: absolute;
    right: 15px;
    /* Keep the icon aligned to the right */
    top: 12px;
    width: 50px;
    /* Make the icon smaller */
  }

  .navbar-collapse {
    max-height: 400px;
    /* Smaller height for small devices */
  }

  /* Smaller size for the person icon */
  .navbar-nav img {
    width: 18px;
    height: 18px;
  }
}

/* iPhone 12 Mini and similar smaller devices */
@media (max-width: 320px) {
  .transparent-navbar {
    background-color: white !important;
    /* Set the navbar background to white */
  }

  .logoNameNavbar {
    font-size: 1rem;
    margin-left: 8px;
  }

  .menu-icon {
    position: absolute;
    right: 12px;
    top: 10px;
    width: 48px;
    /* Smallest icon size for iPhone Mini */
  }

  .navbar-collapse {
    width: 50px;
    border-radius: 5px;
    padding: 20px;
    /* margin-left: 110px; */
    margin-top: 10px;
    overflow: hidden;
  }

  .navbar-nav img {
    width: 16px;
    height: 16px;
  }
}

/* iPad and larger tablets */
@media (min-width: 768px) and (max-width: 1024px) {
  .transparent-navbar {
    background-color: rgb(255, 255, 255) !important;
    /* Set the navbar background to white */
  }

  .logoNameNavbar {
    font-size: 1.4rem;
    /* Adjusted for tablet */
    /* margin-left: 15px; */
  }

  .menu-icon {
    position: absolute;
    right: 25px;
    /* Positioning for tablet */
    top: 15px;
    width: 55px;
    /* Slightly larger icon for tablet */
  }

  .navbar-collapse {
    border-radius: 5px;
    padding: 20px;
    /* margin-left: 110px; */
    margin-top: 10px;
    overflow: hidden;
  }
}





/* Mobile view adjustments */
@media (max-width: 768px) {

  .transparent-navbar {
    background-color: white !important;
    /* Set the navbar background to white */
  }

  .navbar-nav {
    display: flex;
    flex-direction: column;
    /* Stack navbar links vertically */
  }

}




@media (max-width: 768px) {
  .profile-links {
    display: flex;
    flex-direction: column;
    text-shadow: 0 13.36px 8.896px #d4d1a2, 0 -2px 1px #ffe600;
    color: rgb(233, 182, 16);
  }

  .profile-links .nav-link {
    padding: 0.5rem 0;
    /* Add some padding to the links */
    font-weight: 800;
    /* Adjust font weight */
    color: rgb(233, 182, 16);
  }

  .header-accordion-icon {
    margin-left: 190px;
    /* Adjust as needed for smaller screens */
  }
}


/* ============== Course header CSS ================= */
.custom-dropdown {
  position: relative;
  display: inline-block;
}

.custom-dropdown-menu {
  position: absolute;
  background-color: white;
  color: rgb(0, 0, 0);
  border: 1px solid #ccc;
  border-radius: 4px;
  border: 2px solid rgb(233, 182, 16);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-weight: bold;
  font-family: 'Times New Roman', Times, serif;
  z-index: 999;
  padding: 10px;
  display: none;
  opacity: 0;
  transform-origin: top;
  white-space: nowrap;
}

.custom-dropdown-menu.show {
  display: block;
  opacity: 1;
  transform: scaleY(1);
}

.custom-dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}

.custom-dropdown-item:hover {
  background-color: rgba(0, 0, 0, 0.2);
}

.custom-dropdown-item:last-child {
  border-bottom: none;

}`, "",{"version":3,"sources":["webpack://./src/Components/Portal/Portal.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,+EAA+E;EAC/E,wBAAwB;AAC1B;;;AAGA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;EACf,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;;AAEzC;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;;AAEzC;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;;AAEzC;;;AAGA;EACE,yBAAyB;EACzB,uCAAuC;;AAEzC;;;;;;;;;AASA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C;EAC5C,eAAe;EACf,iBAAiB;;AAEnB;;AAEA;EACE,wBAAwB;;AAE1B;;;AAGA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;AACpB;;;;AAIA,8CAA8C;AAC9C;EACE;IACE,kBAAkB;IAClB,yCAAyC;EAC3C;AACF;;;;;AAKA;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,4EAA4E;EAC9E;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,kCAAkC;IAClC,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA,2CAA2C;EAC3C;IACE,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,2CAA2C;EAC7C;;EAEA,8CAA8C;EAC9C;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA,qCAAqC;EACrC;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,kCAAkC;IAClC,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;IACjB,oCAAoC;IACpC,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,uCAAuC;IACvC,SAAS;IACT,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,qCAAqC;EACvC;;EAEA,qCAAqC;EACrC;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,kCAAkC;IAClC,uCAAuC;EACzC;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,uCAAuC;EACzC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,+CAA+C;IAC/C,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,2BAA2B;IAC3B,SAAS;IACT,WAAW;IACX,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;;;;;AAMA,4BAA4B;AAC5B;;EAEE;IACE,kCAAkC;IAClC,uCAAuC;EACzC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kCAAkC;EACpC;;AAEF;;;;;AAKA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,0DAA0D;IAC1D,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,kCAAkC;IAClC,gBAAgB;IAChB,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,yCAAyC;EAC3C;AACF;;;AAGA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,iBAAiB;EACjB,4CAA4C;EAC5C,YAAY;EACZ,aAAa;EACb,aAAa;EACb,UAAU;EACV,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;;AAErB","sourcesContent":[".transparent-navbar {\r\n  background-color: rgba(255, 255, 255, 0.4);\r\n}\r\n\r\n.fixed-navbar {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  z-index: 1000;\r\n}\r\n\r\n.mobile-navbar {\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.desktop-navbar {\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.logoNameNavbar {\r\n  -webkit-backdrop-filter: blur(5px);\r\n  backdrop-filter: blur(5px);\r\n  border-radius: 10px;\r\n  font-weight: 800;\r\n  text-shadow: 2px 2px 4px #000000, 0 13.36px 8.896px #d4d1a2, 0 -2px 1px #ffe600;\r\n  color: rgb(233, 182, 16);\r\n}\r\n\r\n\r\n.logolinkname {\r\n  font-weight: 900;\r\n  font-family: 'Times New Roman', Times, serif;\r\n  font-size: 20px;\r\n  text-shadow: 0 13.96px 12.896px #e9b50a;\r\n  color: rgb(233, 182, 16);\r\n}\r\n\r\n.logolinkname:hover {\r\n  color: rgb(233, 182, 16);\r\n  text-shadow: 0 13.96px 12.896px #41413e;\r\n\r\n}\r\n\r\n.logolinkname:visited {\r\n  color: rgb(255, 255, 255);\r\n  text-shadow: 0 13.96px 12.896px #41413e;\r\n\r\n}\r\n\r\n.logolinkname:active {\r\n  color: rgb(255, 255, 255);\r\n  text-shadow: 0 13.96px 12.896px #41413e;\r\n\r\n}\r\n\r\n\r\n.logolinkname:focus {\r\n  color: rgb(255, 255, 255);\r\n  text-shadow: 0 13.96px 12.896px #41413e;\r\n\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.accordion-item {\r\n  color: rgb(0, 0, 0);\r\n  margin: 20px auto;\r\n  font-family: 'Times New Roman', Times, serif;\r\n  font-size: 17px;\r\n  font-weight: bold;\r\n\r\n}\r\n\r\n.accordion-item:hover {\r\n  background-color: orange;\r\n\r\n}\r\n\r\n\r\n.header-accordion-icon {\r\n  color: rgb(255, 174, 0);\r\n  border: 1px solid rgb(255, 115, 0);\r\n  margin-left: 290px;\r\n}\r\n\r\n\r\n\r\n/* For extra small screens (e.g., iPhone SE) */\r\n@media (max-width: 480px) {\r\n  .header-accordion-icon {\r\n    margin-left: 190px;\r\n    /* Adjust as needed for smaller screens */\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n@media (min-width: 1024px) {\r\n\r\n  .logoNameNavbar {\r\n    font-size: 1.8rem;\r\n  }\r\n\r\n  .navbar-toggler {\r\n    display: none;\r\n  }\r\n}\r\n\r\n\r\n@media (max-width: 1024px) {\r\n  .transparent-navbar {\r\n    background-color: white !important;\r\n  }\r\n\r\n  .logoNameNavbar {\r\n    font-size: 1.5rem;\r\n    margin-left: 20px;\r\n  }\r\n  .logolinkname{\r\n    color: azure;\r\n  }\r\n\r\n  .menu-icon {\r\n    position: absolute;\r\n    right: 20px;\r\n    top: 15px;\r\n    width: 40px;\r\n  }\r\n\r\n  .navbar-collapse {\r\n    border-radius: 5px;\r\n    padding: 20px;\r\n    margin-top: 10px;\r\n    overflow: hidden;\r\n    box-shadow: 0 19px 38px rgba(0, 0, 0, 0.30), 0 15px 12px rgba(0, 0, 0, 0.22);\r\n  }\r\n}\r\n\r\n/* For tablets and larger phones */\r\n@media (max-width: 768px) {\r\n  .transparent-navbar {\r\n    background-color: white !important;\r\n    /* Set the navbar background to white */\r\n  }\r\n\r\n  .logoNameNavbar {\r\n    font-size: 1.3rem;\r\n    /* Smaller logo text */\r\n    margin-left: 10px;\r\n  }\r\n\r\n  /* Positioning the menu icon to the right */\r\n  .menu-icon {\r\n    position: absolute;\r\n    right: 20px;\r\n    /* Align to the right */\r\n    top: 15px;\r\n    width: 35px;\r\n    /* Adjust icon size for tablet view */\r\n  }\r\n\r\n  .navbar-collapse {\r\n    max-height: 500px;\r\n    /* Adjust height for tablets */\r\n  }\r\n\r\n  .navbar-toggler {\r\n    padding: 0.25rem 0.5rem;\r\n    border: none;\r\n    /* Remove the border around the menu icon */\r\n  }\r\n\r\n  /* Aligning the navbar links and person icon */\r\n  .navbar-nav {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n  }\r\n\r\n  /* Smaller size for the person icon */\r\n  .navbar-nav img {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n}\r\n\r\n/* iPhone SE (Small mobile phones) */\r\n@media (max-width: 375px) {\r\n  .transparent-navbar {\r\n    background-color: white !important;\r\n    /* Set the navbar background to white */\r\n  }\r\n\r\n  .logoNameNavbar {\r\n    font-size: 1.1rem;\r\n    /* Even smaller logo for iPhone SE */\r\n    margin-left: 10px;\r\n  }\r\n\r\n  .menu-icon {\r\n    position: absolute;\r\n    right: 15px;\r\n    /* Keep the icon aligned to the right */\r\n    top: 12px;\r\n    width: 50px;\r\n    /* Make the icon smaller */\r\n  }\r\n\r\n  .navbar-collapse {\r\n    max-height: 400px;\r\n    /* Smaller height for small devices */\r\n  }\r\n\r\n  /* Smaller size for the person icon */\r\n  .navbar-nav img {\r\n    width: 18px;\r\n    height: 18px;\r\n  }\r\n}\r\n\r\n/* iPhone 12 Mini and similar smaller devices */\r\n@media (max-width: 320px) {\r\n  .transparent-navbar {\r\n    background-color: white !important;\r\n    /* Set the navbar background to white */\r\n  }\r\n\r\n  .logoNameNavbar {\r\n    font-size: 1rem;\r\n    margin-left: 8px;\r\n  }\r\n\r\n  .menu-icon {\r\n    position: absolute;\r\n    right: 12px;\r\n    top: 10px;\r\n    width: 48px;\r\n    /* Smallest icon size for iPhone Mini */\r\n  }\r\n\r\n  .navbar-collapse {\r\n    width: 50px;\r\n    border-radius: 5px;\r\n    padding: 20px;\r\n    /* margin-left: 110px; */\r\n    margin-top: 10px;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .navbar-nav img {\r\n    width: 16px;\r\n    height: 16px;\r\n  }\r\n}\r\n\r\n/* iPad and larger tablets */\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n  .transparent-navbar {\r\n    background-color: rgb(255, 255, 255) !important;\r\n    /* Set the navbar background to white */\r\n  }\r\n\r\n  .logoNameNavbar {\r\n    font-size: 1.4rem;\r\n    /* Adjusted for tablet */\r\n    /* margin-left: 15px; */\r\n  }\r\n\r\n  .menu-icon {\r\n    position: absolute;\r\n    right: 25px;\r\n    /* Positioning for tablet */\r\n    top: 15px;\r\n    width: 55px;\r\n    /* Slightly larger icon for tablet */\r\n  }\r\n\r\n  .navbar-collapse {\r\n    border-radius: 5px;\r\n    padding: 20px;\r\n    /* margin-left: 110px; */\r\n    margin-top: 10px;\r\n    overflow: hidden;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* Mobile view adjustments */\r\n@media (max-width: 768px) {\r\n\r\n  .transparent-navbar {\r\n    background-color: white !important;\r\n    /* Set the navbar background to white */\r\n  }\r\n\r\n  .navbar-nav {\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* Stack navbar links vertically */\r\n  }\r\n\r\n}\r\n\r\n\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .profile-links {\r\n    display: flex;\r\n    flex-direction: column;\r\n    text-shadow: 0 13.36px 8.896px #d4d1a2, 0 -2px 1px #ffe600;\r\n    color: rgb(233, 182, 16);\r\n  }\r\n\r\n  .profile-links .nav-link {\r\n    padding: 0.5rem 0;\r\n    /* Add some padding to the links */\r\n    font-weight: 800;\r\n    /* Adjust font weight */\r\n    color: rgb(233, 182, 16);\r\n  }\r\n\r\n  .header-accordion-icon {\r\n    margin-left: 190px;\r\n    /* Adjust as needed for smaller screens */\r\n  }\r\n}\r\n\r\n\r\n/* ============== Course header CSS ================= */\r\n.custom-dropdown {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.custom-dropdown-menu {\r\n  position: absolute;\r\n  background-color: white;\r\n  color: rgb(0, 0, 0);\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  border: 2px solid rgb(233, 182, 16);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  font-weight: bold;\r\n  font-family: 'Times New Roman', Times, serif;\r\n  z-index: 999;\r\n  padding: 10px;\r\n  display: none;\r\n  opacity: 0;\r\n  transform-origin: top;\r\n  white-space: nowrap;\r\n}\r\n\r\n.custom-dropdown-menu.show {\r\n  display: block;\r\n  opacity: 1;\r\n  transform: scaleY(1);\r\n}\r\n\r\n.custom-dropdown-item {\r\n  padding: 8px 16px;\r\n  cursor: pointer;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.custom-dropdown-item:hover {\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.custom-dropdown-item:last-child {\r\n  border-bottom: none;\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
